import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Dialog from 'components/custom/ProgressDialog/index'
import { compose, branch, mapProps, renderComponent } from 'recompose'

import { isProfileLoadedSelector } from 'containers/User/Login/selectors'
import { rolesSelector, isLoadedSelector } from 'containers/Role/selectors'
import { isProjectLoadedSelector } from 'containers/Role/Project/selectors'

const mapStateToProps = (state) => {
  return {
    isGlobalLoaded: isProfileLoadedSelector(state) && isLoadedSelector(state),
    isProjectLoaded: isProjectLoadedSelector(state),
    ownRoles: rolesSelector(state)
  }
}

const withTitle = mapProps(({ isGlobalLoaded, isProjectLoaded, ...rest }) => {
  let props
  if (isGlobalLoaded && isProjectLoaded) {
    props = {
      ...rest,
      isGlobalLoaded,
      isProjectLoaded
    }
  } else {
    props = {
      ...rest,
      isGlobalLoaded,
      isProjectLoaded,
      title: 'Checking User Permissions...'
    }
  }
  return props
})

const ProgressDialog = withTitle(Dialog)
const withRoles = connect(mapStateToProps)

const withGlobalLoading = branch(
  ({ isGlobalLoaded }) => !isGlobalLoaded,
  renderComponent(ProgressDialog),
)

const withProjectLoading = branch(
  ({ isProjectLoaded }) => !isProjectLoaded,
  renderComponent(ProgressDialog),
)

const withoutRoleProps = mapProps(({
    isGlobalLoaded,
    isProjectLoaded,
    ownRoles,
    roles,
    dispatch,
    ...rest
  }) => rest
)

const withProjectRoles = compose(
  withRoles,
  withProjectLoading
)

const withGlobalRoles = compose(
  withRoles,
  withGlobalLoading
)

const withAllRoles = compose(
  withRoles,
  withGlobalLoading,
  withProjectLoading,
)

export {
  withGlobalRoles,
  withProjectRoles,
  withAllRoles,
  withoutRoleProps
}
